import Breadcrumb from 'components/Common/Breadcrumb';
import PageLoader from 'components/Common/PageLoader';
import { ErrorMessage, Field, FieldArray, FormikProvider, useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Card, CardBody, Col, Form, FormFeedback, Input, Label, Row } from 'reactstrap';
import { addAirShiiperInfo, addSeaShipperInfo, getAirShipperInfo } from 'store/actions';
import * as Yup from "yup"

const AirShipperInformationForm = ({ quote, shipperId }) => {
  const [validatecontainerDetails, setvalidatecontainerDetails] = useState(false)
  const history = useHistory()
  const dispatch = useDispatch()
  const { shipperData, loader } = useSelector(state => ({
    shipperData: state.GetAirShipperInfo?.shipperInfo,
    loader: state.GetAirShipperInfo.loader,
  }))
  
  const shipperForm = useFormik({
    enableReinitialize: true,
    initialValues: {
      exporter: '',
      exporterPhoneNumber: '',
      MrOrMrs: '',
      consignee: '',
      consigneePhoneNumber: '',
      consigneeCtcPerson: '',
      notifyParty: '',
      notifyPartyPhoneNumber: '',
      notifyPartyCtcPerson: '',
      airLineCounterSignature: '',
      countryOfOrigin: '',
      shippersCOD: '',
      insuranceAmount: '',
      airFreightChargesPrepaid: '',
      airFreightChargesCollected: '',
      otherChargesPrepaid: '',
      otherChargesCollected: '',
      exportLicenceNumber: '',
      cono: '',
      specialInstructions: '',
      declaredValueForCarriage: '',
      declaredValueForCustomers: '',
      to: '',
      containerDetails: [{
        markAndSerialNumber: '',
        kindOfPackages: '',
        descriptionOfGoods: '',
        grossWeight: '',
        measurements: ''
      }],
      status: ''
    },
    validationSchema: Yup.object({
      exporter: Yup.string().required('Exporter is required').max(300, 'Exporter should not exceed 300 characters'),
      exporterPhoneNumber: Yup.string().required('Telephone number is required').max(15, 'Telephone number should not exceed 15 characters'),
      MrOrMrs: Yup.string().required('Name is required').max(40, 'Name should not exceed 40 characters'),
      consignee: Yup.string().required('Consignee is required').max(300, 'Consignee should not exceed 300 characters'),
      consigneePhoneNumber: Yup.string().required('Telephone number is required').max(15, 'Telephone number should not exceed 15 characters'),
      consigneeCtcPerson: Yup.string().required('CTC person is required').max(40, 'CTC person should not exceed 40 characters'),
      notifyParty: Yup.string().required('Notify party is required').max(300, 'Notify party should not exceed 300 characters'),
      notifyPartyPhoneNumber: Yup.string().required('Telephone number is required').max(15, 'Telephone number should not exceed 15 characters'),
      notifyPartyCtcPerson: Yup.string().required('CTC person is required').max(40, 'CTC person should not exceed 40 characters'),
      //don't delete this code
      // consignee: Yup.mixed().test("consignee", "Consignee or notify party is required", value => {
      //   if ((value === undefined || value === '') && (shipperForm.values.notifyParty === undefined || shipperForm.values.notifyParty === '')) {
      //     return false
      //   } else {
      //     return true
      //   }
      // }),
      // consigneePhoneNumber: Yup.string().test('consigneePhoneNumber', 'Telephone number is required', value => {
      //   if ((value === undefined || value === '') && (shipperForm.values.notifyPartyPhoneNumber === undefined || shipperForm.values.notifyPartyPhoneNumber === '')) {
      //     return false
      //   } else {
      //     return true
      //   }
      // }),
      // consigneeCtcPerson: Yup.string().test('consigneeCtcPerson', 'CTC person is required', value => {
      //   if ((value === undefined || value === '') && (shipperForm.values.notifyPartyCtcPerson === undefined || shipperForm.values.notifyPartyCtcPerson === '')) {
      //     return false
      //   } else {
      //     return true
      //   }
      // }),
      // notifyParty: Yup.string().test("notifyParty", "Notify party or consignee is required", value => {
      //   if ((value === undefined || value === '') && (shipperForm.values.consignee === undefined || shipperForm.values.consignee === '')) {
      //     return false
      //   } else {
      //     return true
      //   }
      // }),
      // notifyPartyPhoneNumber: Yup.string().test('notifyPartyPhoneNumber', 'Telephone number is required', value => {
      //   if ((value === undefined || value === '') && (shipperForm.values.consigneePhoneNumber === undefined || shipperForm.values.consigneePhoneNumber === '')) {
      //     return false
      //   } else {
      //     return true
      //   }
      // }),
      // notifyPartyCtcPerson: Yup.string().test('notifyPartyCtcPerson', 'CTC person is required', value => {
      //   if ((value === undefined || value === '') && (shipperForm.values.consigneeCtcPerson === undefined || shipperForm.values.consigneeCtcPerson === '')) {
      //     return false
      //   } else {
      //     return true
      //   }
      // }),
      airLineCounterSignature: Yup.string().required('Air line counter signature is required'),
      countryOfOrigin: Yup.string().required('Country of origin is required').max(20, 'Country of origin should not exceed 20 characters'),
      shippersCOD: Yup.string().required('Shippers COD is required').max(20, 'Shippers COD should not exceed 20 characters'),
      insuranceAmount: Yup.string().required('Insurance amount is required').max(10, 'Insurance amount should not exceed 10 characters'),
      airFreightChargesPrepaid: Yup.string().required('Air freight charges is required'),
      otherChargesPrepaid: Yup.string().required('Other charges is required'),
      exportLicenceNumber: Yup.string().required('Export licence number is required').max(20, 'Export licence number should not exceed 20 characters'),
      cono: Yup.string().required('C.O.No is required').max(20, 'C.O.No should not exceed 20 characters'),
      specialInstructions: Yup.string().required('Special instructions is required').max(300, 'Special instructions should not exceed 300 characters'),
      declaredValueForCarriage: Yup.string().required('Declare value for carriage is required').max(10, 'Declare value for carriage should not exceed 10 characters'),
      declaredValueForCustomers: Yup.string().required('Declare value for customers is required').max(10, 'Declare value for customers should not exceed 10 characters'),
      to: Yup.string().required('TO is required').max(30, 'TO should not exceed 30 characters'),
      containerDetails: Yup.array().of(Yup.object().shape({
        markAndSerialNumber: Yup.string().required('Serial number is required').max(10, 'Serial number should not exceed 10 characters'),
        kindOfPackages: Yup.string().required('Number of packages is required').max(3, 'Number of packages should not exceed 3 characters'),
        descriptionOfGoods: Yup.string().required('Description of goods is required').max(300, 'Description of goods should not exceed 300 characters'),
        grossWeight: Yup.string().required('Gross weight is required').max(8, 'Gross weight should not exceed 8 characters'),
        measurements: Yup.string().required('Measurement is required').max(8, 'Measurement should not exceed 8 characters')
      })),
    }),
    onSubmit: (values) => {
      const shipperInfo = {}
      shipperInfo["exporter"] = values.exporter;
      shipperInfo["exporterPhoneNumber"] = values.exporterPhoneNumber;
      shipperInfo["MrOrMrs"] = values.MrOrMrs;
      shipperInfo["consignee"] = values.consignee;
      shipperInfo["consigneePhoneNumber"] = values.consigneePhoneNumber;
      shipperInfo["consigneeCtcPerson"] = values.consigneeCtcPerson;
      shipperInfo["notifyParty"] = values.notifyParty;
      shipperInfo["notifyPartyPhoneNumber"] = values.notifyPartyPhoneNumber;
      shipperInfo["notifyPartyCtcPerson"] = values.notifyPartyCtcPerson;
      shipperInfo["airLineCounterSignature"] = values.airLineCounterSignature;
      shipperInfo["countryOfOrigin"] = values.countryOfOrigin;
      shipperInfo["shippersCOD"] = values.shippersCOD;
      shipperInfo["insuranceAmount"] = values.insuranceAmount;
      shipperInfo["airFreightChargesPrepaid"] = values.airFreightChargesPrepaid;
      shipperInfo["airFreightChargesCollected"] = values.airFreightChargesCollected;
      shipperInfo["otherChargesPrepaid"] = values.otherChargesPrepaid;
      shipperInfo["otherChargesCollected"] = values.otherChargesCollected;
      shipperInfo["exportLicenceNumber"] = values.exportLicenceNumber;
      shipperInfo["cono"] = values.cono;
      shipperInfo["specialInstructions"] = values.specialInstructions;
      shipperInfo["declaredValueForCarriage"] = values.declaredValueForCarriage;
      shipperInfo["declaredValueForCustomers"] = values.declaredValueForCustomers;
      shipperInfo["to"] = values.to;
      shipperInfo["status"] = values.status;
      shipperInfo["containerDetails"] = values.containerDetails;
      shipperInfo["quoteId"] = quote?._id
      shipperInfo["isRead"] = false;
      if (shipperId) {
        shipperInfo["_id"] = shipperId;
        shipperInfo["siStatusId"] = shipperData?.shipperInfo?.siStatusId;
      }
      dispatch(addAirShiiperInfo(shipperInfo, history))
    },
  })

  useEffect(() => {
    let idx = shipperForm.values.containerDetails.length - 1
    if (
      shipperForm.values.containerDetails[idx].markAndSerialNumber &&
      shipperForm.values.containerDetails[idx].kindOfPackages &&
      shipperForm.values.containerDetails[idx].descriptionOfGoods &&
      shipperForm.values.containerDetails[idx].grossWeight &&
      shipperForm.values.containerDetails[idx].measurements
    ) setvalidatecontainerDetails(true)
    else setvalidatecontainerDetails(false)
  }, [shipperForm.values.containerDetails])

  const containerDetailsValidation = (condition) => {
    let index = shipperForm.values.containerDetails.length - 1
    shipperForm.setFieldTouched(`containerDetails.${index}.markAndSerialNumber`, condition, condition)
    shipperForm.setFieldTouched(`containerDetails.${index}.kindOfPackages`, condition, condition)
    shipperForm.setFieldTouched(`containerDetails.${index}.descriptionOfGoods`, condition, condition)
    shipperForm.setFieldTouched(`containerDetails.${index}.grossWeight`, condition, condition)
    shipperForm.setFieldTouched(`containerDetails.${index}.measurements`, condition, condition)
  }
  const handleAddContainer = (arrayHelpers) => {
    containerDetailsValidation(true)
    validatecontainerDetails &&
      arrayHelpers.insert(shipperForm.values.containerDetails.length + 1,
        {
          markAndSerialNumber: '',
          kindOfPackages: '',
          descriptionOfGoods: '',
          grossWeight: '',
          measurements: '',
        })
  }
  const checkBoxFieldTouched = (condition) => {
    shipperForm.setFieldTouched(`airFreightChargesPrepaid`, condition, condition)
    shipperForm.setFieldTouched(`otherChargesPrepaid`, condition, condition)
  }

  useEffect(() => {
    if (shipperId) {
      dispatch(getAirShipperInfo(shipperId, history))
    }
  }, [shipperId])

  useEffect(() => {
    if (shipperId && shipperData) {
      setFormvalue()
    }
  }, [shipperData])

  const setFormvalue = () => {
    shipperForm.setFieldValue("exporter", shipperData?.shipperInfo?.exporter)
    shipperForm.setFieldValue("exporterPhoneNumber", shipperData?.shipperInfo?.exporterPhoneNumber)
    shipperForm.setFieldValue("MrOrMrs", shipperData?.shipperInfo?.MrOrMrs)
    shipperForm.setFieldValue("consignee", shipperData?.shipperInfo?.consignee)
    shipperForm.setFieldValue("consigneePhoneNumber", shipperData?.shipperInfo?.consigneePhoneNumber)
    shipperForm.setFieldValue("consigneeCtcPerson", shipperData?.shipperInfo?.consigneeCtcPerson)
    shipperForm.setFieldValue("notifyParty", shipperData?.shipperInfo?.notifyParty)
    shipperForm.setFieldValue("notifyPartyPhoneNumber", shipperData?.shipperInfo?.notifyPartyPhoneNumber)
    shipperForm.setFieldValue("notifyPartyCtcPerson", shipperData?.shipperInfo?.notifyPartyCtcPerson)
    shipperForm.setFieldValue("airLineCounterSignature", shipperData?.shipperInfo?.airLineCounterSignature)
    shipperForm.setFieldValue("countryOfOrigin", shipperData?.shipperInfo?.countryOfOrigin)
    shipperForm.setFieldValue("shippersCOD", shipperData?.shipperInfo?.shippersCOD)
    shipperForm.setFieldValue("insuranceAmount", shipperData?.shipperInfo?.insuranceAmount)
    shipperForm.setFieldValue("airFreightChargesPrepaid", shipperData?.shipperInfo?.airFreightChargesPrepaid)
    shipperForm.setFieldValue("airFreightChargesCollected", shipperData?.shipperInfo?.airFreightChargesCollected)
    shipperForm.setFieldValue("otherChargesPrepaid", shipperData?.shipperInfo?.otherChargesPrepaid)
    shipperForm.setFieldValue("otherChargesCollected", shipperData?.shipperInfo?.otherChargesCollected)
    shipperForm.setFieldValue("exportLicenceNumber", shipperData?.shipperInfo?.exportLicenceNumber)
    shipperForm.setFieldValue("cono", shipperData?.shipperInfo?.cono)
    shipperForm.setFieldValue("specialInstructions", shipperData?.shipperInfo?.specialInstructions)
    shipperForm.setFieldValue("declaredValueForCarriage", shipperData?.shipperInfo?.declaredValueForCarriage)
    shipperForm.setFieldValue("declaredValueForCustomers", shipperData?.shipperInfo?.declaredValueForCustomers)
    shipperForm.setFieldValue("to", shipperData?.shipperInfo?.to)
    shipperForm.setFieldValue("status", shipperData?.shipperInfo?.status)
    shipperData?.shipperInfo?.containerDetails?.map((item, index) => {
      shipperForm.setFieldValue(`containerDetails.${index}.markAndSerialNumber`, item.markAndSerialNumber)
      shipperForm.setFieldValue(`containerDetails.${index}.kindOfPackages`, item.kindOfPackages)
      shipperForm.setFieldValue(`containerDetails.${index}.descriptionOfGoods`, item.descriptionOfGoods)
      shipperForm.setFieldValue(`containerDetails.${index}.grossWeight`, item.grossWeight)
      shipperForm.setFieldValue(`containerDetails.${index}.measurements`, item.measurements)
    })
  }

  return (
    <div>
      {loader === true ? <PageLoader /> : null}
      <Breadcrumb title="Enquiries" dashurl="/enquiries" breadcrumbItem={`Air shipper information for enquiry #${quote?.quoteNumber}`} breadcrumbName="Shipper information" />
      <FormikProvider value={shipperForm}>
        <Form
          className="needs-validation"
          encType="multipart/form-data"
          onSubmit={e => {
            e.preventDefault()
            shipperForm.handleSubmit()
            return false
          }}>
          <Card>
            <CardBody>
              <Card>
                <CardBody>
                  <Row>
                    <Col md='6'>
                      <Label>Exporter (Shipper)<span>*</span></Label>
                      <Input
                        name="exporter"
                        type="textarea"
                        className="form-control col-first"
                        id="validationCustom01"
                        onChange={shipperForm.handleChange}
                        onBlur={shipperForm.handleBlur}
                        value={shipperForm.values.exporter || ""}
                        invalid={shipperForm.touched.exporter && shipperForm.errors.exporter ? true : false}
                      />
                      {shipperForm.touched.exporter &&
                        shipperForm.errors.exporter ? (
                        <FormFeedback type="invalid">
                          {shipperForm.errors.exporter}
                        </FormFeedback>
                      ) : null}
                    </Col>
                    <Col md='6'>
                      <Row className='mb-4'>
                        <Col>
                          <Label>Telephone<span>*</span></Label>
                          <Input
                            name="exporterPhoneNumber"
                            onWheel={(e) => e.target.blur()}
                            type='number'
                            className="form-control"
                            id="validationCustom01"
                            onChange={shipperForm.handleChange}
                            onBlur={shipperForm.handleBlur}
                            value={shipperForm.values.exporterPhoneNumber || ""}
                            invalid={shipperForm.touched.exporterPhoneNumber && shipperForm.errors.exporterPhoneNumber ? true : false}
                          />
                          {shipperForm.touched.exporterPhoneNumber &&
                            shipperForm.errors.exporterPhoneNumber ? (
                            <FormFeedback type="invalid">
                              {shipperForm.errors.exporterPhoneNumber}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Label>Mr./Mrs<span>*</span></Label>
                          <Input
                            name="MrOrMrs"
                            type="text"
                            className="form-control"
                            id="validationCustom01"
                            onChange={shipperForm.handleChange}
                            onBlur={shipperForm.handleBlur}
                            value={shipperForm.values.MrOrMrs || ""}
                            invalid={shipperForm.touched.MrOrMrs && shipperForm.errors.MrOrMrs ? true : false}
                          />
                          {shipperForm.touched.MrOrMrs &&
                            shipperForm.errors.MrOrMrs ? (
                            <FormFeedback type="invalid">
                              {shipperForm.errors.MrOrMrs}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <Row>
                    <Col md='6'>
                      <Label>Consignee (If "Order" enter notify party in space below)<span>*</span></Label>
                      <Input
                        name="consignee"
                        type="textarea"
                        className="form-control col-first"
                        id="validationCustom01"
                        onChange={shipperForm.handleChange}
                        onBlur={shipperForm.handleBlur}
                        value={shipperForm.values.consignee || ""}
                        invalid={shipperForm.touched.consignee && shipperForm.errors.consignee ? true : false}
                      />
                      {shipperForm.touched.consignee &&
                        shipperForm.errors.consignee ? (
                        <FormFeedback type="invalid">
                          {shipperForm.errors.consignee}
                        </FormFeedback>
                      ) : null}
                    </Col>
                    <Col md='6'>
                      <Row className='mb-4'>
                        <Col>
                          <Label>Telephone<span>*</span></Label>
                          <Input
                            name="consigneePhoneNumber"
                            onWheel={(e) => e.target.blur()}
                            type='number'
                            className="form-control"
                            id="validationCustom01"
                            onChange={shipperForm.handleChange}
                            onBlur={shipperForm.handleBlur}
                            value={shipperForm.values.consigneePhoneNumber || ""}
                            invalid={shipperForm.touched.consigneePhoneNumber && shipperForm.errors.consigneePhoneNumber ? true : false}
                          />
                          {shipperForm.touched.consigneePhoneNumber &&
                            shipperForm.errors.consigneePhoneNumber ? (
                            <FormFeedback type="invalid">
                              {shipperForm.errors.consigneePhoneNumber}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Label>CTC person<span>*</span></Label>
                          <Input
                            name="consigneeCtcPerson"
                            type="text"
                            className="form-control"
                            id="validationCustom01"
                            onChange={shipperForm.handleChange}
                            onBlur={shipperForm.handleBlur}
                            value={shipperForm.values.consigneeCtcPerson || ""}
                            invalid={shipperForm.touched.consigneeCtcPerson && shipperForm.errors.consigneeCtcPerson ? true : false}
                          />
                          {shipperForm.touched.consigneeCtcPerson &&
                            shipperForm.errors.consigneeCtcPerson ? (
                            <FormFeedback type="invalid">
                              {shipperForm.errors.consigneeCtcPerson}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <Row>
                    <Col md='6'>
                      <Label>Notify Party (Only if not stated above:otherwise leave blank)<span>*</span></Label>
                      <Input
                        name="notifyParty"
                        type="textarea"
                        className="form-control col-first"
                        id="validationCustom01"
                        onChange={shipperForm.handleChange}
                        onBlur={shipperForm.handleBlur}
                        value={shipperForm.values.notifyParty || ""}
                        invalid={shipperForm.touched.notifyParty && shipperForm.errors.notifyParty ? true : false}
                      />
                      {shipperForm.touched.notifyParty &&
                        shipperForm.errors.notifyParty ? (
                        <FormFeedback type="invalid">
                          {shipperForm.errors.notifyParty}
                        </FormFeedback>
                      ) : null}
                    </Col>
                    <Col md='6'>
                      <Row className='mb-4'>
                        <Col>
                          <Label>Telephone<span>*</span></Label>
                          <Input
                            name="notifyPartyPhoneNumber"
                            onWheel={(e) => e.target.blur()}
                            type='number'
                            className="form-control"
                            id="validationCustom01"
                            onChange={shipperForm.handleChange}
                            onBlur={shipperForm.handleBlur}
                            value={shipperForm.values.notifyPartyPhoneNumber || ""}
                            invalid={shipperForm.touched.notifyPartyPhoneNumber && shipperForm.errors.notifyPartyPhoneNumber ? true : false}
                          />
                          {shipperForm.touched.notifyPartyPhoneNumber &&
                            shipperForm.errors.notifyPartyPhoneNumber ? (
                            <FormFeedback type="invalid">
                              {shipperForm.errors.notifyPartyPhoneNumber}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Label>CTC person<span>*</span></Label>
                          <Input
                            name="notifyPartyCtcPerson"
                            type="text"
                            className="form-control"
                            id="validationCustom01"
                            onChange={shipperForm.handleChange}
                            onBlur={shipperForm.handleBlur}
                            value={shipperForm.values.notifyPartyCtcPerson || ""}
                            invalid={shipperForm.touched.notifyPartyCtcPerson && shipperForm.errors.notifyPartyCtcPerson ? true : false}
                          />
                          {shipperForm.touched.notifyPartyCtcPerson &&
                            shipperForm.errors.notifyPartyCtcPerson ? (
                            <FormFeedback type="invalid">
                              {shipperForm.errors.notifyPartyCtcPerson}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <Row>
                    <Col md='6 form-group'>
                      <Label>Airfreight Charges<span>*</span></Label>
                      <div className='radio-group array-element mb-2'>
                        <div className='radio-item'>
                          <Input
                            checked={shipperForm.values.airFreightChargesPrepaid === 'prepaid' ? true : false}
                            name="airFreightChargesPrepaid"
                            type="checkbox"
                            className="form-control"
                            id="prepaid-airFreightCharges"
                            onChange={() => { }}
                            value={`prepaid`}
                            onClick={() => {
                              if (shipperForm.values.airFreightChargesPrepaid === 'prepaid') shipperForm.setFieldValue('airFreightChargesPrepaid', '')
                              else shipperForm.setFieldValue('airFreightChargesPrepaid', 'prepaid')
                            }}
                          />
                          <Label htmlFor='prepaid-airFreightCharges'>To be prepaid</Label>
                        </div>
                        <div className='radio-item'>
                          <Input
                            checked={shipperForm.values.airFreightChargesCollected === 'collected' ? true : false}
                            name="airFreightChargesCollected"
                            type="checkbox"
                            className="form-control"
                            id="collected-airFreightCharges"
                            onChange={() => { }}
                            value={`collected`}
                            onClick={() => {
                              if (shipperForm.values.airFreightChargesCollected === '') shipperForm.setFieldValue('airFreightChargesCollected', 'collected')
                              else shipperForm.setFieldValue('airFreightChargesCollected', '')
                            }}
                          />
                          <Label htmlFor='collected-airFreightCharges'>To be collected (If service availabele)</Label>
                        </div>
                      </div>
                      <ErrorMessage
                        component='span'
                        className='field_error'
                        name={`airFreightChargesPrepaid`}
                      />
                    </Col>
                    <Col md='6 form-group'>
                      <Label>Other Charges<span>*</span></Label>
                      <div className='radio-group array-element mb-2'>
                        <div className='radio-item'>
                          <Input
                            checked={shipperForm.values.otherChargesPrepaid === 'prepaid' ? true : false}
                            name="otherChargesPrepaid"
                            type="checkbox"
                            className="form-control"
                            id="prepaid-otherCharges"
                            onChange={() => { }}
                            value={`prepaid`}
                            onClick={() => {
                              if (shipperForm.values.otherChargesPrepaid === 'prepaid') shipperForm.setFieldValue('otherChargesPrepaid', '')
                              else shipperForm.setFieldValue('otherChargesPrepaid', 'prepaid')
                            }}
                          />
                          <Label htmlFor='prepaid-otherCharges'>To be prepaid</Label>
                        </div>
                        <div className='radio-item'>
                          <Input
                            checked={shipperForm.values.otherChargesCollected === 'collected' ? true : false}
                            name="otherChargesCollected"
                            type="checkbox"
                            className="form-control"
                            id="collected-otherCharges"
                            onChange={() => { }}
                            value={`collected`}
                            onClick={() => {
                              if (shipperForm.values.otherChargesCollected === 'collected') shipperForm.setFieldValue('otherChargesCollected', '')
                              else shipperForm.setFieldValue('otherChargesCollected', 'collected')
                            }}
                          />
                          <Label htmlFor='collected-otherCharges'>To be collected (If service availabele)</Label>
                        </div>
                      </div>
                      <ErrorMessage
                        component='span'
                        className='field_error'
                        name={`otherChargesPrepaid`}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <Row>
                    <Col md='6'>
                      <Row className='mb-4'>
                        <Col>
                          <Label>Export licence number<span>*</span></Label>
                          <Input
                            name="exportLicenceNumber"
                            type="text"
                            className="form-control"
                            id="validationCustom01"
                            onChange={shipperForm.handleChange}
                            onBlur={shipperForm.handleBlur}
                            value={shipperForm.values.exportLicenceNumber || ""}
                            invalid={shipperForm.touched.exportLicenceNumber && shipperForm.errors.exportLicenceNumber ? true : false}
                          />
                          {shipperForm.touched.exportLicenceNumber &&
                            shipperForm.errors.exportLicenceNumber ? (
                            <FormFeedback type="invalid">
                              {shipperForm.errors.exportLicenceNumber}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Label>C.O.No<span>*</span></Label>
                          <Input
                            name="cono"
                            type="text"
                            className="form-control col-first"
                            id="validationCustom01"
                            onChange={shipperForm.handleChange}
                            onBlur={shipperForm.handleBlur}
                            value={shipperForm.values.cono || ""}
                            invalid={shipperForm.touched.cono && shipperForm.errors.cono ? true : false}
                          />
                          {shipperForm.touched.cono &&
                            shipperForm.errors.cono ? (
                            <FormFeedback type="invalid">
                              {shipperForm.errors.cono}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </Row>
                    </Col>
                    <Col md='6'>
                      <Label>Special instructions<span>*</span></Label>
                      <Input
                        name="specialInstructions"
                        type="textarea"
                        className="form-control"
                        id="validationCustom01"
                        onChange={shipperForm.handleChange}
                        onBlur={shipperForm.handleBlur}
                        value={shipperForm.values.specialInstructions || ""}
                        invalid={shipperForm.touched.specialInstructions && shipperForm.errors.specialInstructions ? true : false}
                      />
                      {shipperForm.touched.specialInstructions &&
                        shipperForm.errors.specialInstructions ? (
                        <FormFeedback type="invalid">
                          {shipperForm.errors.specialInstructions}
                        </FormFeedback>
                      ) : null}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <Row>
                    <Col md='4'>
                      <Label>To (Airport of Destination)<span>*</span></Label>
                      <Input
                        name="to"
                        type="text"
                        className="form-control"
                        id="validationCustom01"
                        onChange={shipperForm.handleChange}
                        onBlur={shipperForm.handleBlur}
                        value={shipperForm.values.to || ""}
                        invalid={shipperForm.touched.to && shipperForm.errors.to ? true : false}
                      />
                      {shipperForm.touched.to &&
                        shipperForm.errors.to ? (
                        <FormFeedback type="invalid">
                          {shipperForm.errors.to}
                        </FormFeedback>
                      ) : null}
                    </Col>
                    <Col md='4'>
                      <Label>Country of origin<span>*</span></Label>
                      <Input
                        name="countryOfOrigin"
                        type="text"
                        className="form-control"
                        id="validationCustom01"
                        onChange={shipperForm.handleChange}
                        onBlur={shipperForm.handleBlur}
                        value={shipperForm.values.countryOfOrigin || ""}
                        invalid={shipperForm.touched.countryOfOrigin && shipperForm.errors.countryOfOrigin ? true : false}
                      />
                      {shipperForm.touched.countryOfOrigin &&
                        shipperForm.errors.countryOfOrigin ? (
                        <FormFeedback type="invalid">
                          {shipperForm.errors.countryOfOrigin}
                        </FormFeedback>
                      ) : null}
                    </Col>
                    <Col md='4 form-group'>
                      <Label>Airline Counter Signature<span>*</span></Label>
                      <div className='radio-group array-element mb-2'>
                        <div className='radio-item'>
                          <Input
                            checked={shipperForm.values.airLineCounterSignature === 'yes' ? true : false}
                            name="airLineCounterSignature"
                            type="radio"
                            className="form-control"
                            id="yes-airLineCounterSignature"
                            onChange={() => { }}
                            value={`yes`}
                            onClick={() => {
                              shipperForm.setFieldValue('airLineCounterSignature', 'yes')
                            }}
                          />
                          <Label htmlFor='yes-airLineCounterSignature'>Yes</Label>
                        </div>
                        <div className='radio-item'>
                          <Input
                            checked={shipperForm.values.airLineCounterSignature === 'no' ? true : false}
                            name="airLineCounterSignature"
                            type="radio"
                            className="form-control"
                            id="no-airLineCounterSignature"
                            onChange={() => { }}
                            value={`no`}
                            onClick={() => {
                              shipperForm.setFieldValue('airLineCounterSignature', 'no')
                            }}
                          />
                          <Label htmlFor='no-airLineCounterSignature'>No</Label>
                        </div>
                      </div>
                      <ErrorMessage
                        component='span'
                        className='field_error'
                        name={`airLineCounterSignature`}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <Row>
                    <Col md='3'>
                      <Label>Shipper C.O.D<span>*</span></Label>
                      <Input
                        name="shippersCOD"
                        type="text"
                        className="form-control"
                        id="validationCustom01"
                        onChange={shipperForm.handleChange}
                        onBlur={shipperForm.handleBlur}
                        value={shipperForm.values.shippersCOD || ""}
                        invalid={shipperForm.touched.shippersCOD && shipperForm.errors.shippersCOD ? true : false}
                      />
                      {shipperForm.touched.shippersCOD &&
                        shipperForm.errors.shippersCOD ? (
                        <FormFeedback type="invalid">
                          {shipperForm.errors.shippersCOD}
                        </FormFeedback>
                      ) : null}
                    </Col>
                    <Col md='3'>
                      <Label>Insurance amount<span>*</span></Label>
                      <Input
                        name="insuranceAmount"
                        onWheel={(e) => e.target.blur()}
                        type='number'
                        className="form-control"
                        id="validationCustom01"
                        onChange={shipperForm.handleChange}
                        onBlur={shipperForm.handleBlur}
                        value={shipperForm.values.insuranceAmount || ""}
                        invalid={shipperForm.touched.insuranceAmount && shipperForm.errors.insuranceAmount ? true : false}
                      />
                      {shipperForm.touched.insuranceAmount &&
                        shipperForm.errors.insuranceAmount ? (
                        <FormFeedback type="invalid">
                          {shipperForm.errors.insuranceAmount}
                        </FormFeedback>
                      ) : null}
                    </Col>
                    <Col md='3'>
                      <Label>Declared value for carriage<span>*</span></Label>
                      <Input
                        name="declaredValueForCarriage"
                        onWheel={(e) => e.target.blur()}
                        type='number'
                        className="form-control"
                        id="validationCustom01"
                        onChange={shipperForm.handleChange}
                        onBlur={shipperForm.handleBlur}
                        value={shipperForm.values.declaredValueForCarriage || ""}
                        invalid={shipperForm.touched.declaredValueForCarriage && shipperForm.errors.declaredValueForCarriage ? true : false}
                      />
                      {shipperForm.touched.declaredValueForCarriage &&
                        shipperForm.errors.declaredValueForCarriage ? (
                        <FormFeedback type="invalid">
                          {shipperForm.errors.declaredValueForCarriage}
                        </FormFeedback>
                      ) : null}
                    </Col>
                    <Col md='3'>
                      <Label>Declared value for customers<span>*</span></Label>
                      <Input
                        name="declaredValueForCustomers"
                        onWheel={(e) => e.target.blur()}
                        type='number'
                        className="form-control"
                        id="validationCustom01"
                        onChange={shipperForm.handleChange}
                        onBlur={shipperForm.handleBlur}
                        value={shipperForm.values.declaredValueForCustomers || ""}
                        invalid={shipperForm.touched.declaredValueForCustomers && shipperForm.errors.declaredValueForCustomers ? true : false}
                      />
                      {shipperForm.touched.declaredValueForCustomers &&
                        shipperForm.errors.declaredValueForCustomers ? (
                        <FormFeedback type="invalid">
                          {shipperForm.errors.declaredValueForCustomers}
                        </FormFeedback>
                      ) : null}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <FieldArray name='containerDetails' render={
                (arrayHelpers) => {
                  return <div>
                    <h5 className='mb-4'>Package details</h5>
                    {shipperForm.values.containerDetails.map((details, index) => (
                      <div className='mt-2 position-relative' key={index}>
                        <div className='close-icon float-end position-relative'>
                          <button className='btn close-btn' hidden={shipperForm.values.containerDetails.length > 1 ? false : true} type='button' onClick={() => arrayHelpers.remove(index)}><i className="mdi mdi-close"></i></button>
                        </div>
                        <div className='card'>
                          <div className='card-body'>
                            <Row>
                              <Col md='8'>
                                <Row className='mb-4'>
                                  <Col md='6'>
                                    <div className='form-group'>
                                      <Label>Mark and serial number<span>*</span></Label>
                                      <div className='array-element'>
                                        <Field
                                          type='text'
                                          className='form-control required-field'
                                          name={`containerDetails.${index}.markAndSerialNumber`}
                                          id={`containerDetails.${index}.markAndSerialNumber`}
                                        />
                                        <ErrorMessage
                                          component='span'
                                          className='field_error'
                                          name={`containerDetails.${index}.markAndSerialNumber`}
                                        />
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md='6'>
                                    <div className='form-group'>
                                      <Label>Number of packages<span>*</span></Label>
                                      <div className='array-element'>
                                        <Field
                                          onWheel={(e) => e.target.blur()}
                                          type='number'
                                          className='form-control required-field'
                                          name={`containerDetails.${index}.kindOfPackages`}
                                          id={`containerDetails.${index}.kindOfPackages`}
                                        />
                                        <ErrorMessage
                                          component='span'
                                          className='field_error'
                                          name={`containerDetails.${index}.kindOfPackages`}
                                        />
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md='6'>
                                    <div className='form-group'>
                                      <Label>Gross weight (kg)<span>*</span></Label>
                                      <div className='array-element'>
                                        <Field
                                          onWheel={(e) => e.target.blur()}
                                          type='number'
                                          className='form-control required-field'
                                          name={`containerDetails.${index}.grossWeight`}
                                          id={`containerDetails.${index}.grossWeight`}
                                        />
                                        <ErrorMessage
                                          component='span'
                                          className='field_error'
                                          name={`containerDetails.${index}.grossWeight`}
                                        />
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md='6'>
                                    <div className='form-group'>
                                      <Label>Measurement<span>*</span></Label>
                                      <div className='array-element'>
                                        <Field
                                          onWheel={(e) => e.target.blur()}
                                          type='number'
                                          className='form-control required-field'
                                          name={`containerDetails.${index}.measurements`}
                                          id={`containerDetails.${index}.measurements`}
                                        />
                                        <ErrorMessage
                                          component='span'
                                          className='field_error'
                                          name={`containerDetails.${index}.measurements`}
                                        />
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                              <Col md='4'>
                                <div className='form-group'>
                                  <Label>Description of good's<span>*</span></Label>
                                  <Field component="div" name={`containerDetails.${index}.descriptionOfGoods`} className='array-element'>
                                    <Input
                                      name={`containerDetails.${index}.descriptionOfGoods`}
                                      type="textarea"
                                      className="form-control required-field"
                                      id={`containerDetails.${index}.descriptionOfGoods`}
                                      onChange={(e) => shipperForm.setFieldValue(`containerDetails.${index}.descriptionOfGoods`, e.target.value)}
                                      value={shipperForm.values.containerDetails[index].descriptionOfGoods || ""}
                                    />
                                  </Field>
                                  <ErrorMessage
                                    component='span'
                                    className='field_error'
                                    name={`containerDetails.${index}.descriptionOfGoods`}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className='form-group float-end mt-2'>
                      <button type={'button'} className='primary-button'
                        onClick={() => handleAddContainer(arrayHelpers)}>Add Package</button>
                    </div>
                  </div>
                }}>
              </FieldArray>
            </CardBody>
          </Card>
          <Row className='quotes-button-class justify-content-center mb-5'>
            <Col className='text-center'>
              <Button className='primary-button mx-1' type="submit" onClick={() => {
                checkBoxFieldTouched(true)
                shipperForm.setFieldValue(`status`, `submitted`)
              }}>
                Submit to Admin
              </Button>
              {shipperId ? null : <Button className='btn btn-secondary btn-draft h-100 mx-1' type="submit" onClick={() => {
                checkBoxFieldTouched(true)
                shipperForm.setFieldValue(`status`, `draft`)
              }}>
                Save as Draft
              </Button>}
              <Button className="secountry-btn mx-1" type="reset" onClick={() => {
                if (shipperId) setFormvalue()
                else shipperForm.resetForm()
              }}> Clear </Button>
            </Col>
          </Row>
        </Form>
      </FormikProvider >
    </div >
  )
}

export default AirShipperInformationForm